<template>
  <div class="stack-edit">
    <TemplateSelector ref="TemplateSelector" v-on:selectOk="selectTemplateOk"></TemplateSelector>
    <Modal title="YAML规则" v-model="ruleModal" width="700" :footer-hide="true">
      <Alert show-icon type="success">例：部署三个容器，web和nginx部署到node1，mysql部署到node2，写法如下：</Alert>
      <Alert show-icon>写法一</Alert>
      <codemirror ref="rule1Cm" v-model="rule1" :options="ruleCmOption" class="stack-yaml-rule-cm1"></codemirror>
      <Alert show-icon style="margin-top: 10px">写法二</Alert>
      <codemirror ref="rule2Cm" v-model="rule2" :options="ruleCmOption" class="stack-yaml-rule-cm2"></codemirror>
    </Modal>
    <Card shadow class="content">
      <Spin size="large" fix v-if="loading"></Spin>
      <Alert show-icon type="warning" v-if="dataError">获取堆栈数据失败</Alert>
      <div v-else>
        <!--<Row class="title">-->
          <!--<h4 :style="{float: 'left'}">堆栈</h4>-->
        <!--</Row>-->
        <!--<Divider/>-->
        <Form ref="stackForm" :model="stackForm" :rules="stackFormRules" :label-width="70">
          <FormItem label="堆栈名称" prop="name">
            <Input v-model="stackForm.name" :maxlength="128" placeholder="Stack Name" />
          </FormItem>
        </Form>
        <Row class="title" style="margin-bottom:10px;">
          <h4 :style="{float: 'left'}" style="line-height:24px">
            <Tooltip content="优先级高于容器内配置的环境变量" transfer>全局环境变量</Tooltip>
          </h4>
          <Button icon="md-add" type="primary" size="small" style="margin: 0px 12px" @click="addEnvItem"></Button>
        </Row>
        <Row>
          <div v-for="(env, index) in environmentData" :key="index">
            <Form ref="globalEnvForm" :model="env" :rules="envRules" inline>
              <FormItem prop="envName" style="width: 100%">
                <Input v-model="env.envValue" placeholder="变量值" class="env-value">
                  <Input v-model="env.envName" placeholder="变量名" slot="prepend" style="width: 200px" size="small"/>
                  <Button slot="append" icon="md-close" @click="removeEnvItem(index)"></Button>
                </Input>
              </FormItem>
            </Form>
          </div>
        </Row>
        <Divider/>
        <Form ref="stackForm2" :model="stackForm" :rules="stackFormRules" :label-width="70">
          <FormItem label="部署方式" prop="deploy_type">
            <RadioGroup v-model="stackForm.deploy_type">
              <Radio label="template">模板</Radio>
              <Radio label="yaml">YAML</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div v-if="stackForm.deploy_type === 'template'">
          <Row class="title" style="margin-bottom:10px;">
            <h4 :style="{float: 'left'}" style="line-height:24px">部署容器</h4>
            <Button icon="md-add" type="primary" size="small" style="margin: 0px 12px" @click="openSelectTemplate()"></Button>
          </Row>
          <Card style="margin-bottom: 10px" v-for="(config, index) in configs" :key="index">
            <div slot="title" style="height: 14px">
              <div style="float: left; height: 14px">
                <Icon type="iconfont icon-docker" style="font-family: iconfont" size="12" color="#25B8EB" />
                <span> 容器{{ index + 1 }} <Tag>{{ config.template ? config.template.title : '' }}</Tag></span>
              </div>
              <div style="float: right; height: 14px">
                <i-switch v-model="config.show" size="large">
                  <span slot="open">详细</span>
                  <span slot="close">折叠</span>
                </i-switch>
                <Tooltip content="上移" style="margin-left: 15px">
                  <a v-on:click="configAction('up', index)">
                    <Icon type="md-arrow-up" size="19" />
                  </a>
                </Tooltip>
                <Tooltip content="下移" style="margin-left: 10px">
                  <a v-on:click="configAction('down', index)">
                    <Icon type="md-arrow-down" size="19" />
                  </a>
                </Tooltip>
                <Tooltip content="在下方添加一个容器" style="margin-left: 10px">
                  <a v-on:click="openSelectTemplate(index)">
                    <Icon type="md-add" size="19" />
                  </a>
                </Tooltip>
                <Tooltip content="移除" style="margin-left: 10px">
                  <a v-on:click="configAction('close', index)">
                    <Icon type="md-close" size="19" />
                  </a>
                </Tooltip>
              </div>
            </div>
            <div>
              <Form ref="configForm" :model="config" inline :label-width="70" label-position="right" :rules="configRules">
                <FormItem label="节点" prop="node">
                  <Select v-model="config.node" placeholder="请选择要部署的节点" style="min-width: 168px" >
                    <Option v-for="item in nodes" :key="item.id" :value="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="完成后是否暂停" :label-width="110" prop="is_suspend">
                  <i-switch v-model="config.is_suspend">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="健康检测正常后继续" :label-width="130" prop="is_health_check">
                  <i-switch v-model="config.is_health_check">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem v-if="config.is_health_check" label="检测健康后自动销毁" :label-width="130" prop="is_remove_after_health">
                  <i-switch v-model="config.is_remove_after_health">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="部署后延迟时间(秒)" :label-width="130" prop="delay">
                  <InputNumber v-model="config.delay" style="width:150px" :min="0" />
                </FormItem>
                <Row v-show="config.show">
                  <Divider orientation="left">容器配置</Divider>
                  <FormItem label="容器名称" prop="containerName">
                    <Input v-model="config.containerName" style="min-width: 168px" :maxlength="128" placeholder="容器名称（选填）" />
                  </FormItem>
                  <FormItem label="Hostname" prop="hostname" :label-width="80">
                    <Input v-model="config.hostname" placeholder="Hostname（选填）" style="min-width: 168px"/>
                  </FormItem>
                  <FormItem label="网络模式" prop="network_mode">
                    <Select v-model="config.network_mode" placeholder="请选择网络模式" style="min-width: 168px">
                      <Option v-for="item in networkModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                  <div v-if="config.template && config.template.config_variable">
                    <Divider orientation="left">配置变量</Divider>
                    <div v-for="(configVariableItem, configVariableItemIndex) in config.template.config_variable" :key="configVariableItemIndex">
                      <Form ref="configVariableForm" :model="configVariableItem">
                        <FormItem :label="configVariableItem.text" :prop="configVariableItem.text" style="width: 100%">
                          <Input v-model="config.configVariables[configVariableItem.text]" :placeholder="`配置变量 \`${configVariableItem.text}\``"/>
                        </FormItem>
                      </Form>
                    </div>
                  </div>
                  <div v-if="config.template && config.template.environments">
                    <Divider orientation="left" size="small">
                      <span>环境变量</span>
                    </Divider>
                    <div v-for="(envItem, envItemIndex) in config.template.environments" :key="envItemIndex" v-if="envItem.envMode === 'text' || envItem.envMode === 'select'">
                      <Form ref="envForm" :model="envItem" :rules="environmentRules">
                        <FormItem :label="envItem.envLabel" :prop="envItem.envName" style="width: 100%">
                          <div v-if="envItem.envMode === 'text'">
                            <Input v-model="config.environments[envItem.envName]"/>
                          </div>
                          <div v-else-if="envItem.envMode === 'select'">
                            <Select v-model="config.environments[envItem.envName]">
                              <Option v-for="envOptionItem in envItem.envOption" :key="envOptionItem.envOptionValue" :value="envOptionItem.envOptionValue">{{ envOptionItem.envOptionName }}</Option>
                            </Select>
                          </div>
                          <span style="color: #999" v-if="envItem.envDescription">{{ envItem.envDescription }}</span>
                        </FormItem>
                      </Form>
                    </div>
                  </div>
                  <div>
                    <Divider orientation="left">
                      <span>端口映射</span>
                      <Button icon="md-add" type="success" size="small" style="margin: 6px 12px" @click="addPortsItem(index)"></Button>
                    </Divider>
                    <div v-for="(port, portIndex) in config.portsData" :key="`portIndex_${portIndex}`">
                      <Form ref="portsForm" :model="port" :rules="portsRules" inline>
                        <Row>
                          <Col :lg="6">
                            <FormItem prop="host_address" style="width: 100%" :label-width="5" label="">
                              <Input v-model="port.host_address" placeholder="主机监听地址" />
                            </FormItem>
                          </Col>
                          <Col :lg="6">
                            <FormItem prop="host_port" style="width: 100%" :label-width="5">
                              <Input v-model="port.host_port" placeholder="主机端口" />
                            </FormItem>
                          </Col>
                          <Col :lg="6">
                            <FormItem prop="protocol" style="width: 100%" :label-width="5" label="">
                              <Select v-model="port.protocol" placeholder="协议">
                                <Option v-for="item in protocolList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                              </Select>
                            </FormItem>
                          </Col>
                          <Col :lg="6">
                            <FormItem prop="container_port" style="width: 100%" :label-width="5" label="">
                              <Input v-model="port.container_port" placeholder="容器端口">
                              <Button slot="append" icon="md-close" @click="removePortsItem(portIndex, index)"></Button>
                              </Input>
                            </FormItem>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                  <div>
                    <Divider orientation="left">
                      <span>目录映射</span>
                      <Button icon="md-add" type="success" size="small" style="margin: 6px 12px" @click="addVolumesItem(index)"></Button>
                    </Divider>
                    <div v-for="(volumes, volumesIndex) in config.volumesData" :key="`volumesIndex_${volumesIndex}`">
                      <Form ref="volumesForm" :model="volumes" :rules="volumesRules" inline>
                        <Row>
                          <Col :lg="9">
                            <FormItem prop="hostPath" style="width: 100%" :label-width="5">
                              <Input v-model="volumes.hostPath" placeholder="主机路径" />
                            </FormItem>
                          </Col>
                          <Col :lg="6">
                            <FormItem prop="mode" style="width: 100%" :label-width="5" label="">
                              <Select v-model="volumes.mode" placeholder="模式（默认读写）" clearable>
                                <Option v-for="item in volumesModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                              </Select>
                            </FormItem>
                          </Col>
                          <Col :lg="9">
                            <FormItem prop="bind" style="width: 100%" :label-width="5" label="">
                              <Input v-model="volumes.bind" placeholder="容器路径">
                              <Button slot="append" icon="md-close" @click="removeVolumesItem(volumesIndex, index)"></Button>
                              </Input>
                            </FormItem>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </Row>
              </Form>
            </div>
          </Card>
        </div>
        <div v-else-if="stackForm.deploy_type === 'yaml'" class="stack-edit-yaml">
          <Alert show-icon>语法示例：<a v-on:click="ruleModal = true">查看</a></Alert>
          <Alert show-icon>
            扩展配置
            <Icon type="ios-bulb-outline" slot="icon"></Icon>
            <template slot="desc">
              <p style="color: #ed4014">* 部署节点名称：<b>node</b>: node-name (必填)</p>
              <p>容器部署完成后暂停：<b>is_suspend</b>: true (Bool, default: false)</p>
              <p>健康检测正常后继续：<b>is_health_check</b>: true (Bool, default: false)</p>
              <p>检测健康后自动销毁：<b>is_remove_after_health</b>: true (Bool, default: false)</p>
              <p>部署后延迟时间(秒)：<b>delay</b>: 10 (Second, default: 0)</p>
            </template>
          </Alert>
          <Form ref="stackForm3" :model="stackForm" :rules="stackFormRules" :label-width="0">
            <FormItem label="" prop="yaml">
              <codemirror ref="myCm" v-model="stackForm.yaml" :options="cmOption"></codemirror>
            </FormItem>
          </Form>
        </div>
      </div>
      <div style="text-align: center; box-shadow: 0 4px 18px -4px rgba(0,0,0,.1); padding: 25px 0;">
        <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交</Button>
        <Button @click="$router.go(-1)">取消</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { createContainerStack, detailContainerStack } from '@/api/container/stack'
import { getAllNodes } from '@/api/container/node'
import TemplateSelector from '../template/components/selector'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/mbo.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'

export default {
  name: 'edit',
  components: {
    TemplateSelector,
    codemirror
  },
  data () {
    return {
      loading: false,
      stackForm: {
        id: '',
        name: '',
        deploy_type: 'template',
        yaml: ''
      },
      stackFormRules: {
        name: { required: true, trigger: 'blur', message: '堆栈名称不能为空' },
        deploy_type: { required: true, trigger: 'change', message: '请选择部署方式' }
      },
      submitting: false,
      dataError: false,
      // 网络模式
      networkModeList: [
        { value: 'bridge', label: '桥接模式' },
        { value: 'host', label: '主机模式' },
        { value: 'none', label: '缺省模式' }
      ],
      // 全局环境变量
      environmentData: [],
      envRules: {
        envName: { required: true, trigger: 'blur', message: '变量名不能为空' },
        envValue: { required: true, trigger: 'blur', message: '变量值不能为空' }
      },
      // 容器配置
      configs: [],
      addConfigIndex: null,
      configRules: {
        node: { required: true, type: 'number', trigger: 'change', message: '请选择要部署的节点' },
        network_mode: { required: true, trigger: 'blur', message: '请选择网络模式' },
        is_suspend: { required: true, trigger: 'blur', type: 'boolean', message: '' },
        is_health_check: { required: true, trigger: 'blur', type: 'boolean', message: '' },
        is_remove_after_health: { required: true, trigger: 'blur', type: 'boolean', message: '' }
      },
      // 节点
      nodes: [],
      // 容器环境变量
      environmentRules: {},
      // 端口映射
      protocolList: [
        { value: 'tcp', label: 'TCP' },
        { value: 'udp', label: 'UDP' }
      ],
      portsRules: {
        container_port: { required: true, trigger: 'blur', message: '容器端口不能为空' },
        protocol: { required: true, trigger: 'change', message: '请选择协议' },
        host_address: { required: true, trigger: 'blur', message: '主机监听地址不能为空' },
        host_port: { required: true, trigger: 'blur', message: '主机断开不能为空' }
      },
      // 挂载目录
      volumesModeList: [
        { value: 'rw', label: '读和写' },
        { value: 'ro', label: '只读' },
        { value: 'shared', label: '共享' }
      ],
      volumesRules: {
        hostPath: { required: true, trigger: 'blur', message: '主机路径不能为空' },
        bind: { required: true, trigger: 'blur', message: '容器路径不能为空' }
      },
      // YAML
      cmOption: {
        mode: {
          name: 'yaml'
        },
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true,
        lineWrapping: true,
        theme: 'mbo',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        foldGutter: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        showCursorWhenSelecting: true,
        // 在行槽中添加行号显示器、折叠器、语法检测器
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        // 快捷键
        extraKeys: {
          'Ctrl': 'autocomplete',
          'F11': function (cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'))
          },
          'Esc': function (cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
          }
        }
      },
      ruleCmOption: {
        mode: {
          name: 'yaml'
        },
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'mbo',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        foldGutter: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        readOnly: true,
        showCursorWhenSelecting: true,
        // 在行槽中添加行号显示器、折叠器、语法检测器
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        // 快捷键
        extraKeys: {
          'F11': function (cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'))
          },
          'Esc': function (cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
          }
        }
      },
      ruleModal: false,
      rule1: 'node: {node1-name}\n' +
      'services:\n' +
      '    web:\n' +
      '        image: my_web_site\n' +
      '        restart: always\n' +
      '        links:\n' +
      '            - mysql_db:mysql\n' +
      '        ......\n' +
      '    nginx:\n' +
      '        image: nginx\n' +
      '        volumes:\n' +
      '            - ./conf/mx_nginx.conf:/etc/nginx/conf.d/mx_nginx.conf\n' +
      '        ......\n' +
      '    mysql_db:\n' +
      '        node: {node2-name}\n' +
      '        image: mysql:5.7\n' +
      '        ports:\n' +
      '            - "3306:3306"\n' +
      '        environment:\n' +
      '            - MYSQL_DATABASE=mysitedb\n' +
      '            - MYSQL_ROOT_PASSWORD=123456\n' +
      '        ......',
      rule2: 'web:\n' +
      '    node: {node1-name}\n' +
      '    ......\n' +
      'nginx:\n' +
      '    node: {node1-name}\n' +
      '    ......\n' +
      'image:\n' +
      '    node: {node2-name}\n' +
      '    ......'
    }
  },
  created: function () {
    this.getNodes()
    this.init()
  },
  watch: {
    '$route' () {
      this.init()
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.myCm.editor
      editor.setSize('100%', 600)
      editor.refresh()
      return editor
    }
  },
  methods: {
    // 初始化
    init () {
      if (this.$route.params.id) {
        this.getData()
      }
    },
    getData () {
      this.loading = true
      detailContainerStack(this.$route.params.id).then(res => {
        this.stackForm.id = res.data.id
        this.stackForm.name = res.data.name
        this.stackForm.deploy_type = res.data.deploy_type
        this.stackForm.yaml = res.data.yaml
        if (res.data.deploy_type === 'yaml') {
          this.configs = []
        } else {
          this.configs = res.data.configs
        }
        this.environmentData = res.data.environments
        this.dataError = false
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.dataError = true
        console.log(res.response)
      })
    },
    // 添加全局环境变量
    addEnvItem () {
      this.environmentData.push({
        envName: '',
        envValue: ''
      })
    },
    // 移除全局环境变量
    removeEnvItem (index) {
      this.environmentData.splice(index, 1)
    },
    // 容器配置操作：上移/下移/删除
    configAction (name, index) {
      switch (name) {
        case 'up':
          if (index !== 0) {
            let ss = this.configs
            let a = ss[index - 1]
            ss[index - 1] = ss[index]
            ss[index] = a
            this.configs = []
            this.configs = ss
          }
          break
        case 'down':
          if (index + 1 < this.configs.length) {
            let ss = this.configs
            let a = ss[index + 1]
            ss[index + 1] = ss[index]
            ss[index] = a
            this.configs = []
            this.configs = ss
          }
          break
        case 'close':
          this.configs.splice(index, 1)
          break
      }
    },
    // 添加容器
    addConfig (template, config = {}) {
      let baseConfig = {
        template: template,
        node: null,
        hostname: '',
        containerName: '',
        network_mode: 'bridge',
        delay: 0,
        is_suspend: false,
        is_health_check: false,
        is_remove_after_health: false,
        portsData: [],
        volumesData: [],
        environments: {},
        configVariables: {},
        show: true
      }
      for (let i in config) {
        baseConfig[i] = config[i]
      }
      for (let i in this.configs) {
        this.configs[i].show = false
      }
      if (this.addConfigIndex || this.addConfigIndex === 0) {
        this.configs.splice(this.addConfigIndex + 1, 0, baseConfig)
      } else {
        this.configs.push(baseConfig)
      }
    },
    // 获取节点列表
    getNodes () {
      getAllNodes().then(res => {
        this.nodes = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 添加目录映射
    addVolumesItem (configIndex) {
      this.configs[configIndex].volumesData.push({
        hostPath: '',
        bind: '',
        mode: ''
      })
    },
    // 移除目录映射
    removeVolumesItem (index, configIndex) {
      this.configs[configIndex].volumesData.splice(index, 1)
    },
    // 添加端口映射
    addPortsItem (configIndex) {
      this.configs[configIndex].portsData.push({
        container_port: '',
        protocol: 'tcp',
        host_address: '0.0.0.0',
        host_port: ''
      })
    },
    // 移除端口映射
    removePortsItem (index, configIndex) {
      this.configs[configIndex].portsData.splice(index, 1)
    },
    openSelectTemplate (index = null) {
      this.addConfigIndex = index
      this.$refs.TemplateSelector.openSelectModal()
    },
    // 选择模板完成后回调
    selectTemplateOk (data) {
      let config = {}
      if (data.config) {
        config.containerName = data.config.name ? data.config.name : ''
        config.hostname = data.config.hostname ? data.config.hostname : ''
        config.network_mode = data.config.network_mode ? data.config.network_mode : 'bridge'
        if (data.config.volumes) {
          config.volumesData = []
          for (let i in data.config.volumes) {
            config.volumesData.push({
              hostPath: i,
              bind: data.config.volumes[i].bind,
              mode: data.config.volumes[i].mode
            })
          }
        }
        if (data.config.ports) {
          config.portsData = []
          for (let i in data.config.ports) {
            const port = data.config.ports[i]
            let host = i.split('/')
            let protocol = 'tcp'
            if (host.length > 1) {
              protocol = host[1]
            }
            config.portsData.push({
              container_port: host[0],
              protocol: protocol,
              host_address: port[0],
              host_port: port[1]
            })
          }
        }
      }
      if (data.environments) {
        config.environments = {}
        for (let i in data.environments) {
          config.environments[data.environments[i].envName] = data.environments[i].envValue
        }
      }
      if (data.config_variable) {
        config.configVariables = {}
        for (let i in data.config_variable) {
          config.configVariables[data.config_variable[i].text] = ''
        }
      }
      const templateData = {
        config: data.config,
        config_variable: data.config_variable,
        environments: data.environments,
        id: data.id,
        title: data.title
      }
      this.addConfig(templateData, config)
    },
    // 表单校验
    validForm () {
      let allValid = true
      this.$refs.stackForm.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      this.$refs.stackForm2.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      this.$refs.stackForm3.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      for (let i in this.$refs.configForm) {
        this.$refs.configForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.globalEnvForm) {
        this.$refs.globalEnvForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.envForm) {
        this.$refs.envForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.volumesForm) {
        this.$refs.volumesForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.portsForm) {
        this.$refs.portsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      return allValid
    },
    // 获取提交数据
    getRunReqData () {
      let data = {
        id: this.stackForm.id,
        name: this.stackForm.name,
        deploy_type: this.stackForm.deploy_type,
        environments: this.environmentData
      }
      if (data.deploy_type === 'yaml') {
        data.yaml = this.stackForm.yaml
      } else {
        data.configs = this.configs
      }
      return data
    },
    // 提交
    submit () {
      if (this.stackForm.deploy_type === 'template' && !this.configs.length) {
        this.$Notice.warning({title: '请添加要部署的容器！'})
        return
      } else if (this.stackForm.deploy_type === 'yaml' && !this.stackForm.yaml) {
        this.$Notice.warning({title: '请填写YAML！'})
        return
      }
      const allValid = this.validForm()
      if (allValid) {
        const reqData = this.getRunReqData()
        this.submitting = true
        createContainerStack(reqData, reqData.id).then(res => {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.submitting = false
          this.$router.go(-1)
        }).catch(res => {
          this.submitting = false
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .env-value .ivu-input-default {
    height: 34px;
  }
  @media screen and (max-width:768px){
    .stack-edit{
      .ivu-card-head{
        padding:14px 5px;
        .ivu-tooltip {
          margin-left:5px!important;
        }
      }
      .ivu-tag{
        padding:0 5px;
      }
    }
  }
  .stack-yaml-rule-cm1 {
    .CodeMirror {
      height: 500px;
    }
  }
  .stack-yaml-rule-cm2 {
    .CodeMirror {
      height: 200px;
    }
  }
  .stack-edit-yaml {
    .CodeMirror {
      font-size: 14px;
      height: 500px;
    }
    .CodeMirror-fullscreen {
      z-index: 999 !important;
    }
    .CodeMirror-hints {
      z-index: 1000 !important;
    }
  }
</style>
